import { render, staticRenderFns } from "./TableCommunication.vue?vue&type=template&id=3b7f56a6"
import script from "./TableCommunication.vue?vue&type=script&lang=js"
export * from "./TableCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports